// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ylm5a","section-3-flex":"styles_section-3-flex__rOpVz","incubation-cards-container":"styles_incubation-cards-container__Uc-7K"};